import { Box } from '@chakra-ui/layout';
import { faMagnifyingGlass } from '@fortawesome/pro-light-svg-icons';
import { FAIcon, LoadingIndicator, Typography } from '@sgi/gravity';
import { z } from 'zod';
import { Form } from '../../forms/components/Form';
import { FormInput } from '../../forms/components/FormInput';

interface Props {
  initialLastName?: string;
  initialFirstName?: string;
  onSubmit: ({ firstName, lastName }: { firstName: string; lastName: string }) => void;
  isLoading: boolean;
}

export const CustomerSearchByName = ({ initialLastName, initialFirstName, onSubmit, isLoading }: Props) => {
  return (
    <Box backgroundColor="white" borderRadius="lg" my={4}>
      <Box width="584px" padding="40px">
        <Form
          schema={z
            .object({
              firstName: z.string().min(1, 'Required'),
            })
            .or(z.object({ lastName: z.string().min(1, 'Required') }))}
          initialValues={{
            firstName: initialFirstName,
            lastName: initialLastName,
          }}
          onSubmit={onSubmit}
        >
          <FormInput
            data-testid="search-input"
            name="firstName"
            label={<Typography variant="h4">Search by Customer Number</Typography>}
            placeholder="Enter First Name"
            isRequired
          />
          <FormInput
            data-testid="search-input"
            name="lastName"
            placeholder="Enter Last Name"
            inputLeftElement={<FAIcon icon={faMagnifyingGlass} />}
            inputRightAddon={
              <Box cursor="pointer" as="button">
                {isLoading ? (
                  <Box pt="4px">
                    <LoadingIndicator />
                  </Box>
                ) : (
                  <>SEARCH</>
                )}
              </Box>
            }
          />
        </Form>
      </Box>
    </Box>
  );
};
